export default "__VITE_ASSET__DySEZBOS__"